<template>
  <div class="container" style="text-align: center">
    <strong style="font-weight: 900">Chamados não avaliados</strong>
    <br />
    <hr style="margin: 10px 0; color: #fff" />
    <span>
      Parece que você tem chamados <br />
      com avaliação pendente!
    </span>
    <br />
    <button class="action" @click.stop="clicked">
      <strong> Avaliar </strong>
    </button>
  </div>
</template>

<style scoped>
.action {
  width: 100%;
  background: #0f3565;
  padding: 8px 1px;
  border-radius: 5px;
  margin-top: 10px;
}
</style>

<script>
import router from '../router'
import ApiService from '../services/ApiService'

export default {
  props: {
    toastId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      apiService: new ApiService(),
    }
  },

  methods: {
    clicked() {
      this.user = JSON.parse(localStorage.getItem('user'))
      const institution = JSON.parse(localStorage.getItem('institution'))

      this.apiService
        .get(`called/pendent-rating/${institution.id}`)
        .then((response) => {
          this.user.pendingCalleds = response.content

          const calledId = this.user.pendingCalleds[0].id

          router.push('/calleds')
          router.replace({ query: { calledId } })

          this.$toast.update(this.toastId, {
            content: 'Redirecionando para a avaliação do chamado!',
            options: { type: 'success' },
          })
        })
    },
  },
}
</script>
